import { useCallback } from 'react';
import { QUERY_PARAM } from '@config/routing';
import { parseQueryPage } from '@helpers/lists';
import { AppFCC } from '@types';
import { useNavigator } from '@hooks/routing';
import { PaginationWidgetProps } from '@widgets/pagination/types';
import { Pagination } from '@kit/pagination';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const PaginationWidget: AppFCC<PaginationWidgetProps> = props => {
  const {
    className,
    pageSize = 10,
    totalCount,
    maxVisiblePages,
    pageOnClick
  } = props;
  const navigator = useNavigator();
  const query = navigator.getQuery();
  const firstPage = 1;
  const queryPage = parseQueryPage(query) ?? firstPage;
  const totalPages = Math.ceil(totalCount / pageSize) || firstPage;
  const page = queryPage > totalPages ? totalPages : queryPage;
  const getPageDescriptor = useCallback((processingPage: number) => {
    const pathname = navigator.getPathname();
    const match = navigator.findMatch(pathname);
    if (!match) {
      return;
    }
    const query = navigator.getQuery();
    return match.route.getDescriptor({
      ...query,
      [QUERY_PARAM.PAGE]: processingPage > 1 //
      ? String(processingPage) : undefined,
      [QUERY_PARAM.KEEP_RESULTS]: undefined
    });
  }, [navigator]);
  return _jsx(Pagination //
  , {
    className: className,
    page: page,
    totalPages: totalPages,
    maxVisiblePages: maxVisiblePages,
    getPageDescriptor: getPageDescriptor,
    pageOnClick: pageOnClick
  });
};